<template>
    <div id="loginComponent" class="container-login container-fluid">
        <div class="login">
            <b-col cols="12" sm="8"  md="6" lg="4" xl="4" offset-sm="2" offset-md="3" offset-lg="4" offset-xl="4" >
                <div class="panel panel-default">
                    <div class="panel-body">
                        <b-row>
                            <div class="center-block">
                                <img class="logoLoginBan" src="../../assets/img/endesa.png" alt="consentimiento">
                            </div>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <hr>
                                <div class="form-group">
                                    <label>Usuario:</label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="glyphicon glyphicon-user"></i>
                                        </span>
                                        <input
                                            type="text"
                                            id="user"
                                            ref="loginname"
                                            class="form-control"
                                            placeholder="Usuario"
                                            autofocus=""
                                            required=""
                                            v-on:keyup.enter="goResume">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Contraseña:</label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="glyphicon glyphicon-lock"></i>
                                        </span>
                                        <input
                                            type="password"
                                            id="password"
                                            ref="password"
                                            class="form-control"
                                            placeholder="Contraseña"
                                            value=""
                                            required=""
                                            v-on:keyup.enter="goResume">
                                    </div>
                                </div>
                                <div class="form-group form-btn-login btnEntrarLogin">
                                    <input id= "loginBtn" type="submit" @click="goResume" class="btn btn-primary" value="Entrar">
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
        </div>
    </div>
</template>
<script>

import utils from '@/securityMixin';
const $ = require('jquery')
window.$ = $
export default {
    name: 'login',
    mixins: [utils],
    data(){
        return{
            payload:{
                username: null,
                password: null,
            }
        }
    },
    created(){
        this.$session.start()
        this.changeEnv()
    },
    methods:{
        goResume(){
			this.$session.set('settings', this.refactorEnv)
            this.payload.password = this.$refs.password.value
            this.payload.username = this.$refs.loginname.value
            let urlLog = this.refactorEnv.loginUrl

            this.$http.post(urlLog, this.payload)
                .then(response => {
                    this.login(response)
                }).catch((error) =>{
                    console.log(error)
                }
            )

        },
        login(response){
            let tokenSend=response.data.token
            this.$session.set('token',tokenSend)
            this.$session.set('rol',response.data.id_rol == 2 ? this.$constants.roleSuperAdmin:this.$constants.roleAgent)
            this.$session.set('user',response.data.username)
            this.$session.set('id',response.data.idUser)
            this.$bus.$emit(this.$constants.busEventOnLogin)
            var destiny = this.userLoginDestiny(this.$session)
            this.$router.push({
                name: destiny
            }).catch(err => {})
        },
        changeEnv(){
				var vm = this
				var envUrl = location.origin + this.$constants.url_get_env;
				var fromClient = this.$constants.cod_cliente;
				var ajax_settings = {
					"url": envUrl,
					"method": "GET",
					"timeout": 0,
					"headers": {
						"From": fromClient
					},
				};

				$.ajax(ajax_settings).done(function (response) {
					vm.refactorEnv = response.settings
					console.log('finish changeEnv')
				});
            }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/login/login.vue